<ion-header>

  <ion-toolbar color="--ion-color-light-teal-2" class="ion-text-center">
    <ion-buttons slot="start">
      <ion-button>
      </ion-button>
    </ion-buttons>
    <ion-title class="ion-text-center">
      Coupons
    </ion-title>

    <!-- <img class="amoLogo modal-logo" src="assets/icons/logo_orange.png" /> -->
    <ion-buttons slot="end">
      <ion-button id="paymentCouponDismissBtn" (click)="dismiss()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>

  <ion-row>
    <ion-col>

      <div>
        <ion-row class="ion-justify-content-center">
          <ion-col size="11">
            <ion-text color="primary">
              Enter coupon code and select from the applicable experiences to apply discount.
            </ion-text>
          </ion-col>
        </ion-row>
        <ion-row class="text-center ion-justify-content-center">
          <ion-col size="9">
            <ion-list inset="true" lines="none">
              <ion-item>
                <ion-label position="stacked">Enter Coupon Code:</ion-label>
                <ion-input type="text" [(ngModel)]="couponCode"></ion-input>
              </ion-item>
            </ion-list>
          </ion-col>
        </ion-row>


        <div class="ion-text-center">
          <ion-button id="paymentCouponCodeSubmitBtn" color="secondary" type="button" size="large"
            (click)="submitCode($event)">Submit</ion-button>
        </div>
      </div>
      <div>

        <ion-row class="ion-justify-content-center">
          <ion-col size="9">

            <ion-list>
              <ion-item lines="none" *ngIf="couponResponse?.validcoupon === false" class="ion-text-center">
                <ion-text color="danger">
                  <ion-icon *ngIf="!couponResponse?.validcoupon" color="danger" name="alert"></ion-icon>
                  {{ couponResponse?.message }}
                </ion-text>
              </ion-item>
              <ion-item lines="none" *ngIf="couponResponse?.validcoupon === true" class="ion-text-center">
                <ion-text color="green" *ngIf="couponResponse?.validcoupon">
                  <ion-icon *ngIf="couponResponse?.validcoupon === true" color="green" name="checkmark-circle-outline">
                  </ion-icon>
                  {{couponResponse?.message}}
                </ion-text>
              </ion-item>
            </ion-list>
          </ion-col>
        </ion-row>


        <ion-row class="ion-justify-content-center">
          <ion-col size="9">

            <ion-list>

              <ion-item lines="none"
                *ngFor="let application of LocalApplicationDisplayList; let i = index; trackBy: trackByIndex">
                <ion-label class="ion-text-wrap" *ngIf="application?.isCouponDisabled === false" color="secondary">
                  {{application?.name}}
                </ion-label>
                <ion-label class="ion-text-wrap" *ngIf="application?.isCouponDisabled === true">{{application?.name}}
                  <p  color="disabled">{{application?.message}}</p>
                </ion-label>
                <ion-checkbox slot="start" [disabled]="application?.isCouponDisabled"
                  (ionChange)="checkboxCoupon($event, application)"></ion-checkbox>
              </ion-item>
            </ion-list>

          </ion-col>
        </ion-row>
      </div>
    </ion-col>
  </ion-row>
  <ion-grid>

  </ion-grid>

</ion-content>
<ion-footer>
  <ion-row class="ion-justify-content-center">
    <ion-col size="9">

      <ion-button id="paymentCouponCodeApplyBtn" color="secondary" type="button" size="full"
        (click)="applyCoupon($event)" [disabled]="checkboxList.length === 0">Apply
      </ion-button>
    </ion-col>
  </ion-row>

</ion-footer>